
// eslint-disable-next-line no-unused-vars
import DanceFilter from "@/model/dance_filter";
// eslint-disable-next-line no-unused-vars
import { defineComponent, watch, ref, PropType, reactive } from "vue";

export default defineComponent({
	props:
	{
		setDanceFilter: Object as PropType<DanceFilter>,
		activeFilter: String
	},
	emits: ["set-dance-filter-clicked"],
	setup(
		props,
		{ emit }
	) 
	{
		const currentlyActiveFilter = ref(props.activeFilter);
		const danceFilterToApply = ref(props.setDanceFilter);

		if (danceFilterToApply?.value) 
		{
			watch(danceFilterToApply, applyInactiveFilter);
		}
		if (currentlyActiveFilter?.value) 
		{
			watch(currentlyActiveFilter, applyInactiveFilter);
		}

		function selectFilter(filterName: string) 
		{
			
			emit("set-dance-filter-clicked", filterName);
			currentlyActiveFilter.value = filterName;
		}

		function applyInactiveFilter() 
		{
			return danceFilterToApply?.value?.dance !== currentlyActiveFilter?.value ? "site-btn-outline-primary" : "site-btn-primary";
		}

		return {
			// eslint-disable-next-line vue/no-dupe-keys
			danceFilterToApply,
			applyInactiveFilter,
			selectFilter
		};
	},
});
